import {t} from "../../../i18n";
import ProgressiveImage from '../../../commonComponent/image/ProgressiveImage';
import SectionPanel, {SectionCopy} from '../../../commonComponent/section/SectionPanel';
import {imageAssets} from '../../../assets/imageAssets';

const AboutUs = () => { return (
    <section data-reveal className="content-row about-row">
        <SectionPanel title={t("home.restaurant")}>
            <SectionCopy
                paragraphs={[
                    t("aboutUsEtablishmentTextFirstParagraph"),
                    t("aboutUsEtablishmentTextSecondParagraph"),
                ]}
            />
        </SectionPanel>

        <div className="media-panel">
            <ProgressiveImage asset={imageAssets.presentation} sizes="(max-width: 639px) 100vw, 50vw"
                              alt={t("altAboutUs")} className="panel-image"/>
        </div>
    </section>
); };

export default AboutUs;
